import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdminInitialWorkCalendarDataForProject } from 'scenes/WorkDemo/services/getAdminInitialWorkCalendarDataForProject.service';
import { loadUsersAndPersonalResources } from 'store/projectUsers/thunks/loadUsersAndPersonalResources';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadInitialCalendarDataForAdmin = createAsyncThunk(
  'workCalendar/loadInitialCalendarDataForAdmin',
  async (_, { getState, dispatch }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const calendarDataPromise = getAdminInitialWorkCalendarDataForProject(
      selectedProjectId,
      activeEmployerInfo
    );

    const [calendarData] = await Promise.all([calendarDataPromise]);

    if (calendarData.resources && calendarData.resources.length > 0) {
      dispatch(loadUsersAndPersonalResources(calendarData.resources));
    }

    const allData = {
      projectId: selectedProjectId,
      ...calendarData,
    };

    return allData;
  }
);
